import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import KeyboardAccessible from '../Accessibility/KeyboardAccessible/KeyboardAccessible';

const DropdownChildren = (props) => {
  const {
    children,
    closeMenu,
    closeOnDropdownClick,
    dropdownMenuClassName,
    handleOutsideClick,
    id,
    position,
  } = props;

  useEffect(() => {
    document.addEventListener('mouseup', handleOutsideClick, false);
    document.addEventListener('keyup', handleOutsideClick, false);
    return () => {
      document.removeEventListener('keyup', handleOutsideClick, false);
      document.removeEventListener('mouseup', handleOutsideClick, false);
    };
  }, []);

  const dropdownMenuClasses = cn(
    'c-dropdown__menu',
    `c-dropdown__menu--${position}`,
    dropdownMenuClassName
  );

  return (
    <KeyboardAccessible>
      <div
        className={dropdownMenuClasses}
        aria-labelledby={id}
        {...(closeOnDropdownClick ? { onClick: closeMenu } : {})}
      >
        {children}
      </div>
    </KeyboardAccessible>
  );
};

export default DropdownChildren;

DropdownChildren.propTypes = {
  children: PropTypes.node,
  closeMenu: PropTypes.func.isRequired,
  closeOnDropdownClick: PropTypes.bool.isRequired,
  dropdownMenuClassName: PropTypes.string.isRequired,
  handleOutsideClick: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
};

DropdownChildren.defaultProps = {
  children: null,
};
